import React from 'react';

import useGroup from 'hooks/useGroup';

function MoveGroup(props) {
	let {
		active,
		setFetchingGroup,
		setActive,
		disabled
	} = props;

	const {
		activeMoveGroup,
		moveGroup
	} = useGroup();

	return (
		<button
			className={'btntool btn btn-primary p-0' + (active ? ' active' : '') + (disabled ? ' disabled' : '')}
			type="button"
			onClick={() => {
				setFetchingGroup(true);
				setActive(5);
				activeMoveGroup(!moveGroup);
			}}
		>
			{active === false && (
				<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none"
				     strokeLinecap="round" strokeLinejoin="round" className="css-i6dzq1">
					<polyline points="5 9 2 12 5 15"></polyline>
					<polyline points="9 5 12 2 15 5"></polyline>
					<polyline points="15 19 12 22 9 19"></polyline>
					<polyline points="19 9 22 12 19 15"></polyline>
					<line x1="2" y1="12" x2="22" y2="12"></line>
					<line x1="12" y1="2" x2="12" y2="22"></line>
				</svg>
			)}
			{active === true && (
				<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none"
				     strokeLinecap="round" strokeLinejoin="round" className="css-i6dzq1">
					<polyline points="9 11 12 14 22 4"></polyline>
					<path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
				</svg>
			)}
		</button>
	);
}

export default MoveGroup;
